export function FeatureSection({ features }) {
  return (
    <section className="content-section" id="features">
      <div className="section-heading">
        <p className="eyebrow">FEATURES</p>
        <h2>NASをもっと身近に。</h2>
      </div>

      <div className="feature-grid">
        {features.map((feature) => (
          <article className="feature-card" key={feature.number}>
            <span className="feature-number">{feature.number}</span>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
